import PalowanStack from './PalowanStack';

export default PalowanStack;
